'use client';

import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { LanguageValue } from './config-locales';

import { allLangs } from './all-langs';
import { fallbackLng } from './config-locales';

export function useTranslate(ns?: string) {
  const { t, i18n } = useTranslation(ns);
  // const router = useRouter();

  const fallback = allLangs.filter((lang) => lang.value === fallbackLng)[0];

  const currentLang = allLangs.find((lang) => lang.value === i18n.resolvedLanguage);
  const onChangeLang = useCallback(
    async (newLang: LanguageValue) => {
      try {
        i18n.changeLanguage(newLang);

        if (currentLang) {
          dayjs.locale(currentLang.adapterLocale);
        }

        // Add a slight delay before refreshing
        setTimeout(() => {
          // router.refresh();
        }, 200); // Adjust delay time as needed, 200ms should be a safe bet.
      } catch (error) {
        console.error(error);
      }
    },
    [currentLang, i18n]
  );

  return {
    t,
    i18n,
    onChangeLang,
    currentLang: currentLang ?? fallback,
  };
}
